import { createReducer, on } from '@ngrx/store'

import { ReusableFunctionSummaryWithManifestInfo } from '@flowx/designer/modules/reusable-resources/reusable-functions/models/reusable-function.entity'

import { ReusableFunctionsActions } from '../actions/reusable-functions.actions'

export const reusableFunctionsFeatureKey = 'reusableFunctions'

export type ReusableFunctionsState = {
  loading: boolean
  reusableFunctions: ReusableFunctionSummaryWithManifestInfo[]
}

export const initialState: ReusableFunctionsState = {
  loading: false,
  reusableFunctions: [],
}

export const reusableFunctionsReducer = createReducer(
  initialState,
  on(ReusableFunctionsActions.getReusableFunctions, (state) => ({
    ...state,
    loading: true,
  })),
  on(ReusableFunctionsActions.getReusableFunctionsSuccess, (state, { reusableFunctions }) => ({
    ...state,
    loading: false,
    reusableFunctions,
  })),
  on(ReusableFunctionsActions.getReusableFunctionsFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(ReusableFunctionsActions.cleanupReusableFunctions, () => initialState)
)
